import { useCallback } from 'react';
import { useClientNavigate } from '../../../Routing/useClientNavigate';
import { journalSearch } from './storageJournalFilters';
import type { StockRow, StockView } from './Stock/stockView';

/** Opens the Lagerjournal limited to a Bestand row of a Lagerort. */
// @ai-generated 2026-10-23T14:40:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useOpenStorageJournal() {
    const navigate = useClientNavigate();

    return useCallback(
        (storageLocation: { id: string; name: string }, view: StockView, row: StockRow) =>
            navigate(`/storage_transactions/list${journalSearch(storageLocation, view, row)}`),
        [navigate],
    );
}
